import { forwardRef } from "react";

export const ExportIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
      <path
        d="M5.375 13.7632H2C1.60218 13.7632 1.22064 13.6079 0.93934 13.3315C0.658035 13.0552 0.5 12.6803 0.5 12.2895V1.97368C0.5 1.58284 0.658035 1.208 0.93934 0.931632C1.22064 0.655263 1.60218 0.5 2 0.5H7.25L11 4.18421V7.86842M7.25 12.2895H12.5M12.5 12.2895L10.25 10.0789M12.5 12.2895L10.25 14.5"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExportAsPNGIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
      <path
        stroke="#1E1E1E"
        d="M1 3.42A2.42 2.42 0 0 1 3.42 1h8.16A2.42 2.42 0 0 1 14 3.42v8.16A2.42 2.42 0 0 1 11.58 14H3.42A2.42 2.42 0 0 1 1 11.58z"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m1 9.732 3.696-3.076c.36-.31.767-.472 1.182-.472s.823.163 1.182.472L11 10.184M14 9c-.629-.694-1.358-1.405-1.358-1.405-.367-.39-.783-.595-1.207-.595s-.84.205-1.207.595l-.729.703"
      ></path>
      <mask id="path-4-inside-1_1_506145" fill="#fff">
        <circle cx="9.799" cy="4.025" r="0.605"></circle>
      </mask>
      <circle cx="9.799" cy="4.025" r="0.605" fill="#1E1E1E"></circle>
      <path
        fill="#1E1E1E"
        d="M10.404 4.025h-1c0-.218.177-.395.395-.395v2c.887 0 1.605-.719 1.605-1.605zM9.8 4.63v-1c.219 0 .395.177.395.395h-2c0 .886.719 1.605 1.605 1.605zm-.605-.605h1a.395.395 0 0 1-.395.395v-2c-.886 0-1.605.719-1.605 1.605zM9.8 3.42v1a.395.395 0 0 1-.395-.395h2c0-.886-.718-1.605-1.605-1.605z"
        mask="url(#path-4-inside-1_1_506145)"
      ></path>
    </svg>
  );
};

export const ExportAsPDFIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" fill="none" viewBox="0 0 14 17">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.487 1v3.328a.83.83 0 0 0 .832.833h3.329"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 8.49V2.663A1.664 1.664 0 0 1 2.664 1H8.49l4.16 4.16v3.33M1 13.483h1.248a1.248 1.248 0 1 0 0-2.497H1v4.993M11.106 13.605h1.584M13.482 10.986h-2.497v4.993M5.995 10.986v4.993h.832a1.664 1.664 0 0 0 1.664-1.664V12.65a1.664 1.664 0 0 0-1.664-1.665z"
      ></path>
    </svg>
  );
};

export const SaveAsTemplateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" fill="none" viewBox="0 0 13 15">
      <path
        stroke="#1E1E1E"
        d="M5.469 13.316H2.375c-.365 0-.714-.144-.972-.401A1.37 1.37 0 0 1 1 11.947V2.368A1.376 1.376 0 0 1 2.375 1h4.813l3.437 3.421v3.421m-3.437 4.105H12m0 0L9.938 9.895M12 11.947 9.938 14"
      ></path>
    </svg>
  );
};

export const SaveInLibraryIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none" viewBox="0 0 14 13">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        d="M1 8.55v1.707c0 .985.798 1.783 1.783 1.783h8.913c.984 0 1.782-.798 1.782-1.783V8.55"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.24 1.195v7.28M5.16 6.395l2.08 2.08M9.318 6.395l-2.08 2.08"
      ></path>
    </svg>
  );
};

export const PreferencesIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M14.167 4.958H7.792M9.917 12.042H3.542M12.042 14.167a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25M4.958 7.083a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25"
      ></path>
    </svg>
  );
};

export const CursorsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        d="M.564 1.691A.891.891 0 0 1 1.69.564l10.826 3.608c.753.251.827 1.288.116 1.643l-4.28 2.14a.9.9 0 0 0-.398.399l-2.14 4.28c-.355.71-1.392.636-1.643-.117z"
      ></path>
    </svg>
  );
};

export const CursorsHideIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 17">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        d="M1.564 3.691A.891.891 0 0 1 2.69 2.564l10.826 3.608c.753.251.827 1.288.116 1.643l-4.28 2.14a.9.9 0 0 0-.398.399l-2.14 4.28c-.355.71-1.392.636-1.643-.117zM13.028.707.707 14.041"
      ></path>
    </svg>
  );
};

export const MouseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" fill="none" viewBox="0 0 13 17">
      <rect width="12" height="16" x="0.5" y="0.5" stroke="#1E1E1E" rx="4.5"></rect>
      <path stroke="#000" d="M0 6.583h12.278"></path>
      <path stroke="#000" strokeLinecap="round" d="M6.5 2.5v2.542"></path>
    </svg>
  );
};

export const TrackpadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
      <rect width="13" height="13" x="0.5" y="0.5" stroke="#1E1E1E" rx="2.2"></rect>
      <path stroke="#000" d="M0 8.5h13.458"></path>
      <path stroke="#000" strokeLinecap="round" d="M7 8.5v5"></path>
    </svg>
  );
};

export const AutoDetectIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <g
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        clipPath="url(#clip0_1_535918)"
      >
        <path d="M6 10.666a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333"></path>
        <path d="M10 14.666a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333"></path>
      </g>
      <defs>
        <clipPath id="clip0_1_535918">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const TooltipIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((_, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 13 13" ref={ref}>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        d="M6.389 3.944v.223M6.389 3.944v.223M6.389 6.389v2.666M6.389 6.389v2.666"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 6.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0"
      ></path>
    </svg>
  );
});

TooltipIcon.displayName = "TooltipIcon";
